import LocalizedStrings from 'localized-strings';

interface InternationalTransferPayoutFeesLocalizedType {
  toolTip: string;
}

export default new LocalizedStrings<InternationalTransferPayoutFeesLocalizedType>(
  {
    en: {
      toolTip:
        'We charge a handling fee of {variableFee} excl. VAT of the amount sent (with a minimum of {minimumFee} excl. VAT) per international transfer.',
    },
    fr: {
      toolTip:
        'Nous facturons des frais de gestion de {variableFee} HT du montant envoyé (avec un minimum de {minimumFee} HT), lorsque vous émettez un virement international.',
    },
  } as const,
);
